import script from "./setting.vue?vue&type=script&setup=true&lang=js"
export * from "./setting.vue?vue&type=script&setup=true&lang=js"

import "./setting.vue?vue&type=style&index=0&id=818af6d6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818af6d6"]])

export default __exports__